import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'coach-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {

  constructor(
    private translate: TranslateService,
  ) {
  }

  ngOnInit(): void {
    this.translate.addLangs(['tr']);
    this.translate.setDefaultLang('tr');
    this.translate.use('tr');
  }
}
